<template>
    <ElementLayout>
        <template #element>
            <div class="vf-input-group">
                <input
                    ref="visibleInput"
                    type="tel"
                    inputmode="decimal"
                    class="vf-input-field"
                    data-money
                    :placeholder="placeholder"
                />
            </div>
            <input ref="hiddenInput" type="hidden" :name="el$.name" :value="el$.model ?? ''" />
        </template>

        <template v-for="(component, slot) in elementSlots" #[slot]>
            <slot :name="slot" :el$="el$">
                <component :is="component" :el$="el$" />
            </slot>
        </template>
    </ElementLayout>
</template>

<script>
import { defineElement } from '@vueform/vueform'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import IMask from 'imask'

export default defineElement({
    name: 'MoneyElement',

    props: {
        placeholder: { type: String, default: 'e.g. 1,000' },
        decimals: { type: Number, default: 2 },
    },

    setup(props, { element }) {
        const visibleInput = ref(null)
        const hiddenInput = ref(null)
        let mask = null

        const toNumber = (value) => {
            if (value == null || value === '') {
                return null
            }

            const normalized = String(value).replaceAll(',', '').trim()
            if (normalized === '') {
                return null
            }

            const parsed = Number(normalized)
            return Number.isFinite(parsed) ? parsed : null
        }

        onMounted(() => {
            const input = visibleInput.value
            if (!input || input._im) return

            mask = IMask(input, {
                mask: Number,
                scale: props.decimals,
                radix: '.',
                thousandsSeparator: ',',
                padFractionalZeros: props.decimals > 0,
                normalizeZeros: true,
                min: props.decimals > 0 ? 0.01 : 0,
                autofix: true,
            })
            input._im = mask

            const initialValue = hiddenInput.value?.value || element.model
            const initialNumber = toNumber(initialValue)

            if (initialNumber != null) {
                mask.value = String(initialNumber)
            }

            mask.on('accept', () => {
                const raw = mask.unmaskedValue
                const n = raw === '' ? null : Number(raw)
                if (element.model !== n) element.update(n)
            })
        })

        onBeforeUnmount(() => {
            if (mask) {
                mask.destroy()
                mask = null
            }
        })

        return { visibleInput, hiddenInput, placeholder: props.placeholder }
    },
})
</script>
